(function($) {
  $(document).ready(function() {
    $('.tabs').once('sw-tabs').each(function() {
      var t = new Tabs($(this));
    });
  });
})(jQuery);

var Tabs = function( $wrap ) {
  var _this = this;

  this.default_ease = 'back.out(1.7)';
  this.default_duration = 0.7;

  this.$wrap = $wrap;
  this.$titles = this.$wrap.find('.tabs__title');
  this.$contents_wrap = this.$wrap.find('.tabs__contents');
  this.$contents = this.$wrap.find('.tabs__content');

  this.current = null;
  this.timeline = null;

  // First check hash
  setTimeout(function() {
    if ( window.location.hash ) {
      _this.hash_check(location.hash, true);
    }
  }, 100);

  if ( !this.current ) {
    // If no hash, check classes
    var $c = this.$contents.filter('.tabs__content--active');
    if ( !$c.length && !this.$wrap.hasClass('tabs--no-open-init') ) {
      $c = this.$contents.first();
    }
    if ( $c.length ) {
      var cur = $c.attr('id');
      this.open(cur, true);
    }
  }

  this.$titles.on('click',function(e) {
    e.preventDefault();
    var hash = jQuery(this).attr('href');
    _this.hash_check(hash);
  });

  this.$wrap.addClass('tabs--initialized');
  this.$wrap.data('sw-tabs', this);

};
Tabs.prototype.hash_check = function ( hash, no_anim ) {
  var $c = this.$contents.filter(hash);
  if ( $c.length ) {
    this.open($c.attr('id'), no_anim);
    return true;
  }
  return false;
};
Tabs.prototype.open = function( id, no_anim ) {
  var _this = this;
  if ( id !== this.current ) {
    var $content_active = this.$contents.filter('#'+id);
    var $content_others = this.$contents.not($content_active);
    var $title_active = this.$titles.filter('[href="#'+id+'"]');
    var $title_others = this.$titles.not($title_active);
    $title_others.removeClass('tabs__title--active');
    $title_active.addClass('tabs__title--active');
    if ( this.timeline ) {
      this.timeline.pause();
      this.timeline.kill();
      this.timeline = null;
    }
    if ( no_anim ) {
      requestAnimationFrame( function() {
        $content_others.removeClass('tabs__content--active');
        $content_active.addClass('tabs__content--active');
        $content_others.hide();
        $content_active.show();
        jQuery(window).resize();
      });
    } else {
      $content_others.removeClass('tabs__content--active');
      this.timeline = gsap.timeline();
      this.timeline.to($content_others.toArray(), {
        y: '1rem',
        opacity: 0,
        ease: this.default_ease,
        duration: this.default_duration/2,
        onComplete: function () {
          $content_others.hide();
          $content_active.show();
          $content_active.addClass('tabs__content--active');
        },
      });
      this.timeline.fromTo($content_active.toArray(), {
        y: '2rem',
        opacity: 0,
      }, {
        y: '0rem',
        opacity: 1,
        ease: this.default_ease,
        duration: this.default_duration,
        onComplete: function () {
          _this.timeline.kill();
          _this.timeline = null;
        },
      });
    }
    this.current = id;
  }
};
